"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
var CommonValues = _interopRequireWildcard(require("../utils/common-values"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableBodyRow extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "rotateIconStyle", isOpen => ({
      transform: isOpen ? "rotate(90deg)" : "none"
    }));
  }
  renderColumns() {
    const size = CommonValues.elementSize(this.props);
    const mapArr = this.props.columns.filter(columnDef => !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)).sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder).map((columnDef, index) => {
      const value = this.props.getFieldValue(this.props.data, columnDef);
      if (this.props.data.tableData.editCellList && this.props.data.tableData.editCellList.find(c => c.tableData.id === columnDef.tableData.id)) {
        return /*#__PURE__*/React.createElement(this.props.components.EditCell, {
          components: this.props.components,
          icons: this.props.icons,
          localization: this.props.localization,
          columnDef: columnDef,
          size: size,
          key: "cell-" + this.props.data.tableData.id + "-" + columnDef.tableData.id,
          rowData: this.props.data,
          cellEditable: this.props.cellEditable,
          onCellEditFinished: this.props.onCellEditFinished,
          scrollWidth: this.props.scrollWidth
        });
      } else {
        return /*#__PURE__*/React.createElement(this.props.components.Cell, {
          size: size,
          errorState: this.props.errorState,
          icons: this.props.icons,
          columnDef: (0, _objectSpread2.default)({
            cellStyle: this.props.options.cellStyle
          }, columnDef),
          value: value,
          key: "cell-" + this.props.data.tableData.id + "-" + columnDef.tableData.id,
          rowData: this.props.data,
          cellEditable: columnDef.editable !== "never" && !!this.props.cellEditable,
          onCellEditStarted: this.props.onCellEditStarted,
          scrollWidth: this.props.scrollWidth
        });
      }
    });
    return mapArr;
  }
  renderActions() {
    const size = CommonValues.elementSize(this.props);
    const actions = CommonValues.rowActions(this.props);
    const width = actions.length * CommonValues.baseIconSize(this.props);
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      size: size,
      padding: "none",
      key: "key-actions-column",
      style: (0, _objectSpread2.default)({
        width: width,
        padding: "0px 5px",
        boxSizing: "border-box"
      }, this.props.options.actionsCellStyle)
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement(this.props.components.Actions, {
      data: this.props.data,
      actions: actions,
      components: this.props.components,
      size: size,
      disabled: this.props.hasAnyEditingRow
    })));
  }
  renderSelectionColumn() {
    let checkboxProps = this.props.options.selectionProps || {};
    if (typeof checkboxProps === "function") {
      checkboxProps = checkboxProps(this.props.data);
    }
    const size = CommonValues.elementSize(this.props);
    const selectionWidth = CommonValues.selectionMaxWidth(this.props, this.props.treeDataMaxLevel);
    const styles = size === "medium" ? {
      marginLeft: this.props.level * 9
    } : {
      padding: "4px",
      marginLeft: 5 + this.props.level * 9
    };
    return /*#__PURE__*/React.createElement(_TableCell.default, {
      size: size,
      padding: "none",
      key: "key-selection-column",
      style: {
        width: selectionWidth
      }
    }, /*#__PURE__*/React.createElement(_Checkbox.default, (0, _extends2.default)({
      size: size,
      checked: this.props.data.tableData.checked === true,
      onClick: e => e.stopPropagation(),
      value: this.props.data.tableData.id.toString(),
      onChange: event => this.props.onRowSelected(event, this.props.path, this.props.data),
      style: styles
    }, checkboxProps)));
  }
  renderDetailPanelColumn() {
    const size = CommonValues.elementSize(this.props);
    const CustomIcon = _ref => {
      let {
        icon,
        iconProps
      } = _ref;
      return typeof icon === "string" ? /*#__PURE__*/React.createElement(_Icon.default, iconProps, icon) : React.createElement(icon, (0, _objectSpread2.default)({}, iconProps));
    };
    if (typeof this.props.detailPanel == "function") {
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        size: size,
        padding: "none",
        key: "key-detail-panel-column",
        style: (0, _objectSpread2.default)({
          width: 42,
          textAlign: "center"
        }, this.props.options.detailPanelColumnStyle)
      }, /*#__PURE__*/React.createElement(_IconButton.default, {
        size: size,
        style: (0, _objectSpread2.default)({
          transition: "all ease 200ms"
        }, this.rotateIconStyle(this.props.data.tableData.showDetailPanel)),
        onClick: event => {
          this.props.onToggleDetailPanel(this.props.path, this.props.detailPanel);
          event.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement(this.props.icons.DetailPanel, null)));
    } else {
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        size: size,
        padding: "none",
        key: "key-detail-panel-column"
      }, /*#__PURE__*/React.createElement("div", {
        style: (0, _objectSpread2.default)({
          width: 42 * this.props.detailPanel.length,
          textAlign: "center",
          display: "flex"
        }, this.props.options.detailPanelColumnStyle)
      }, this.props.detailPanel.map((panel, index) => {
        if (typeof panel === "function") {
          panel = panel(this.props.data);
        }
        const isOpen = (this.props.data.tableData.showDetailPanel || "").toString() === panel.render.toString();
        let iconButton = /*#__PURE__*/React.createElement(this.props.icons.DetailPanel, null);
        let animation = true;
        if (isOpen) {
          if (panel.openIcon) {
            iconButton = /*#__PURE__*/React.createElement(CustomIcon, {
              icon: panel.openIcon,
              iconProps: panel.iconProps
            });
            animation = false;
          } else if (panel.icon) {
            iconButton = /*#__PURE__*/React.createElement(CustomIcon, {
              icon: panel.icon,
              iconProps: panel.iconProps
            });
          }
        } else if (panel.icon) {
          iconButton = /*#__PURE__*/React.createElement(CustomIcon, {
            icon: panel.icon,
            iconProps: panel.iconProps
          });
          animation = false;
        }
        iconButton = /*#__PURE__*/React.createElement(_IconButton.default, {
          size: size,
          key: "key-detail-panel-" + index,
          style: (0, _objectSpread2.default)({
            transition: "all ease 200ms"
          }, this.rotateIconStyle(animation && isOpen)),
          disabled: panel.disabled,
          onClick: event => {
            this.props.onToggleDetailPanel(this.props.path, panel.render);
            event.stopPropagation();
          }
        }, iconButton);
        if (panel.tooltip) {
          iconButton = /*#__PURE__*/React.createElement(_Tooltip.default, {
            key: "key-detail-panel-" + index,
            title: panel.tooltip
          }, iconButton);
        }
        return iconButton;
      })));
    }
  }
  renderTreeDataColumn() {
    const size = CommonValues.elementSize(this.props);
    if (this.props.data.tableData.childRows && this.props.data.tableData.childRows.length > 0) {
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        size: size,
        padding: "none",
        key: "key-tree-data-column",
        style: {
          width: 48 + 9 * (this.props.treeDataMaxLevel - 2)
        }
      }, /*#__PURE__*/React.createElement(_IconButton.default, {
        size: size,
        style: (0, _objectSpread2.default)({
          transition: "all ease 200ms",
          marginLeft: this.props.level * 9
        }, this.rotateIconStyle(this.props.data.tableData.isTreeExpanded)),
        onClick: event => {
          this.props.onTreeExpandChanged(this.props.path, this.props.data);
          event.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement(this.props.icons.DetailPanel, null)));
    } else {
      return /*#__PURE__*/React.createElement(_TableCell.default, {
        padding: "none",
        key: "key-tree-data-column"
      });
    }
  }
  getStyle(index, level) {
    let style = {
      transition: "all ease 300ms"
    };
    if (typeof this.props.options.rowStyle === "function") {
      style = (0, _objectSpread2.default)({}, style, this.props.options.rowStyle(this.props.data, index, level, this.props.hasAnyEditingRow));
    } else if (this.props.options.rowStyle) {
      style = (0, _objectSpread2.default)({}, style, this.props.options.rowStyle);
    }
    if (this.props.onRowClick) {
      style.cursor = "pointer";
    }
    if (this.props.hasAnyEditingRow) {
      style.opacity = style.opacity ? style.opacity : 0.2;
    }
    return style;
  }
  render() {
    const size = CommonValues.elementSize(this.props);
    const renderColumns = this.renderColumns();
    if (this.props.options.selection) {
      renderColumns.splice(0, 0, this.renderSelectionColumn());
    }
    if (this.props.actions && this.props.actions.filter(a => a.position === "row" || typeof a === "function").length > 0) {
      if (this.props.options.actionsColumnIndex === -1) {
        renderColumns.push(this.renderActions());
      } else if (this.props.options.actionsColumnIndex >= 0) {
        let endPos = 0;
        if (this.props.options.selection) {
          endPos = 1;
        }
        renderColumns.splice(this.props.options.actionsColumnIndex + endPos, 0, this.renderActions());
      }
    }

    // Then we add detail panel icon
    if (this.props.detailPanel) {
      if (this.props.options.detailPanelColumnAlignment === "right") {
        renderColumns.push(this.renderDetailPanelColumn());
      } else {
        renderColumns.splice(0, 0, this.renderDetailPanelColumn());
      }
    }

    // Lastly we add tree data icon
    if (this.props.isTreeData) {
      renderColumns.splice(0, 0, this.renderTreeDataColumn());
    }
    this.props.columns.filter(columnDef => columnDef.tableData.groupOrder > -1).forEach(columnDef => {
      renderColumns.splice(0, 0, /*#__PURE__*/React.createElement(_TableCell.default, {
        size: size,
        padding: "none",
        key: "key-group-cell" + columnDef.tableData.id
      }));
    });
    const _this$props = this.props,
      {
        icons,
        data,
        columns,
        components,
        detailPanel,
        getFieldValue,
        isTreeData,
        onRowClick,
        onRowSelected,
        onTreeExpandChanged,
        onToggleDetailPanel,
        onEditingCanceled,
        onEditingApproved,
        options,
        hasAnyEditingRow,
        treeDataMaxLevel,
        localization,
        actions,
        errorState,
        cellEditable,
        onCellEditStarted,
        onCellEditFinished,
        scrollWidth
      } = _this$props,
      rowProps = (0, _objectWithoutProperties2.default)(_this$props, ["icons", "data", "columns", "components", "detailPanel", "getFieldValue", "isTreeData", "onRowClick", "onRowSelected", "onTreeExpandChanged", "onToggleDetailPanel", "onEditingCanceled", "onEditingApproved", "options", "hasAnyEditingRow", "treeDataMaxLevel", "localization", "actions", "errorState", "cellEditable", "onCellEditStarted", "onCellEditFinished", "scrollWidth"]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_TableRow.default, (0, _extends2.default)({
      selected: hasAnyEditingRow
    }, rowProps, {
      hover: onRowClick ? true : false,
      style: this.getStyle(this.props.index, this.props.level),
      onClick: event => {
        onRowClick && onRowClick(event, this.props.data, panelIndex => {
          let panel = detailPanel;
          if (Array.isArray(panel)) {
            panel = panel[panelIndex || 0];
            if (typeof panel === "function") {
              panel = panel(this.props.data);
            }
            panel = panel.render;
          }
          onToggleDetailPanel(this.props.path, panel);
        });
      }
    }), renderColumns), this.props.data.tableData && this.props.data.tableData.showDetailPanel && /*#__PURE__*/React.createElement(_TableRow.default
    // selected={this.props.index % 2 === 0}
    , null, /*#__PURE__*/React.createElement(_TableCell.default, {
      size: size,
      colSpan: renderColumns.length,
      padding: "none"
    }, this.props.data.tableData.showDetailPanel(this.props.data))), this.props.data.tableData.childRows && this.props.data.tableData.isTreeExpanded && this.props.data.tableData.childRows.map((data, index) => {
      if (data.tableData.editing) {
        return /*#__PURE__*/React.createElement(this.props.components.EditRow, {
          columns: this.props.columns.filter(columnDef => {
            return !columnDef.hidden;
          }),
          components: this.props.components,
          data: data,
          icons: this.props.icons,
          localization: this.props.localization,
          getFieldValue: this.props.getFieldValue,
          key: index,
          mode: data.tableData.editing,
          options: this.props.options,
          isTreeData: this.props.isTreeData,
          detailPanel: this.props.detailPanel,
          onEditingCanceled: onEditingCanceled,
          onEditingApproved: onEditingApproved,
          errorState: this.props.errorState
        });
      } else {
        return /*#__PURE__*/React.createElement(this.props.components.Row, (0, _extends2.default)({}, this.props, {
          data: data,
          index: index,
          key: index,
          level: this.props.level + 1,
          path: [...this.props.path, index],
          onEditingCanceled: onEditingCanceled,
          onEditingApproved: onEditingApproved,
          hasAnyEditingRow: this.props.hasAnyEditingRow,
          treeDataMaxLevel: treeDataMaxLevel,
          errorState: this.props.errorState,
          cellEditable: cellEditable,
          onCellEditStarted: onCellEditStarted,
          onCellEditFinished: onCellEditFinished
        }));
      }
    }));
  }
}
exports.default = MTableBodyRow;
MTableBodyRow.defaultProps = {
  actions: [],
  index: 0,
  data: {},
  options: {},
  path: []
};
MTableBodyRow.propTypes = {
  actions: _propTypes.default.array,
  icons: _propTypes.default.any.isRequired,
  index: _propTypes.default.number.isRequired,
  data: _propTypes.default.object.isRequired,
  detailPanel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]))]),
  hasAnyEditingRow: _propTypes.default.bool,
  options: _propTypes.default.object.isRequired,
  onRowSelected: _propTypes.default.func,
  path: _propTypes.default.arrayOf(_propTypes.default.number),
  treeDataMaxLevel: _propTypes.default.number,
  getFieldValue: _propTypes.default.func.isRequired,
  columns: _propTypes.default.array,
  onToggleDetailPanel: _propTypes.default.func.isRequired,
  onRowClick: _propTypes.default.func,
  onEditingApproved: _propTypes.default.func,
  onEditingCanceled: _propTypes.default.func,
  errorState: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool])
};